import { useEffect, useState } from "react";
import InputData from "./InputData";
import InputIconSearchPanel from "./InputIconSearchPanel";
import { focusElement, inputOnEnter } from "../js/utils";
import moment from "moment";
import { useSuppliers } from "../hooks/useSuppliers";

export function DeliveryNoteHeader({ data, onChange }) {
  const [header, setHeader] = useState(data);
  const supplierList = useSuppliers(-1)[0];
  const supplierListFiltered = supplierList.filter((e) =>
    e.nombre.includes(header.proveedor),
  );

  const handleHeader = (field, value) => {
    setHeader((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  useEffect(() => {
    onChange(header);
  }, [header]);

  useEffect(() => {
    focusElement(10);
  }, []);

  // console.log("CABECERA: ", header);

  return (
    <div style={{ display: "flex", flexDirection: "row", gap: 40 }}>
      <div>
        <div className="opt-table-title">Datos albarán</div>
        <div className="opt-table-content grid-5" id="delivery-note-grid">
          <div className="cell cell-label cell-extra">Proveedor (*)</div>
          <div className="cell-extra combined-cells-4">
            <InputIconSearchPanel
              size={0}
              tabIndex={10}
              type={"type-alphanum-ext"}
              options={supplierListFiltered}
              input={header.proveedor}
              onChange={(e) => {
                handleHeader("proveedor", e);
              }}
              onClear={() => {
                handleHeader("proveedor", "");
                handleHeader("idProveedor", "");
              }}
              onSelect={(e) => {
                handleHeader("proveedor", e.nombre);
                handleHeader("idProveedor", e.id);
              }}
            ></InputIconSearchPanel>
          </div>
          <div className="cell cell-label cell-extra">Número albarán</div>
          <div className="cell-extra">
            <InputData
              tabIndex={11}
              maxLength={20}
              type="type-alphanum-ext"
              size={0}
              input={header.numeroAlbaran}
              onChange={(e) => {
                handleHeader("numeroAlbaran", e);
              }}
            ></InputData>
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-extra">Número factura</div>
          <div className="cell-extra">
            <InputData
              tabIndex={13}
              maxLength={20}
              inactive={true}
              type="type-alphanum-ext"
              size={0}
              input={header.numeroFactura}
              onChange={() => {}}
            ></InputData>
          </div>
          <div className="cell cell-label cell-extra">Fecha albarán</div>
          <div className="cell">
            <input
              type="date"
              tabIndex={12}
              step={1}
              max="9999-12-31"
              className="input-field input-cell"
              value={header.fechaAlbaran}
              onChange={(e) => {
                const value = e.target.value;
                handleHeader(
                  "fechaAlbaran",
                  value ? moment(value).format("YYYY-MM-DD") : "",
                );
              }}
              onKeyUp={(e) => inputOnEnter(e)}
            ></input>
          </div>
          <div className="cell"></div>
          <div className="cell cell-label cell-extra">Fecha factura</div>
          <div className="cell">
            <InputData
              tabIndex={14}
              maxLength={20}
              inactive={true}
              type="type-alphanum-ext"
              size={0}
              input={
                header.fechaFactura
                  ? moment(header.fechaFactura).format("DD/MM/YYYY")
                  : ""
              }
              onChange={() => {}}
            ></InputData>
          </div>
        </div>
      </div>
    </div>
  );
}
